var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoitLogoHeroSquare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0769 10.2046C19.656 10.795 19.6383 11.7361 19.038 12.323C18.4476 12.9 17.4761 12.8901 16.9112 12.3011C16.3476 11.7142 16.366 10.7257 16.9501 10.1685C17.5496 9.59653 18.4964 9.61279 19.0769 10.2053V10.2046Z",
    fill: "#EB6087"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9926 14.1899C15.0174 11.3828 15.0032 8.57579 14.9997 5.76875C14.9983 4.80288 14.3657 4.12571 13.4897 4.125C12.6179 4.125 11.9888 4.80995 11.9881 5.77158C11.9874 6.98511 11.9938 8.19864 11.9973 9.48222C11.7822 9.40297 11.6372 9.34778 11.4907 9.29683C8.97094 8.41587 6.1915 9.56501 5.0275 11.9694C3.86916 14.3625 4.67087 17.2424 6.91891 18.6534C8.65252 19.7417 10.4696 19.8174 12.2577 18.8374C14.0649 17.8467 14.9742 16.249 14.9926 14.1899ZM8.1197 15.7968C7.2996 14.9109 7.33285 13.4334 8.19046 12.6317C9.09902 11.7833 10.5538 11.8272 11.3796 12.728C12.2132 13.6372 12.1657 15.0461 11.2742 15.8725C10.3748 16.7068 8.9299 16.6721 8.11899 15.7961L8.1197 15.7968Z",
    fill: "#EB6087"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoitLogoHeroSquare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/doit-logo-hero-square.d915dfdc769bcc0d02d4f3009348248c.svg";